import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { DynamicTableColumnTemplate } from '../column-template.directive';
import { FlowPipe, GetPipe } from '@lockton-apps/shared/util/ng-lodash';
import { identity } from 'lodash';

interface TextProps {
  path: string;
  classNames: string;
  parsers?: <T>(value: T) => string;
}

@Component({
    selector: 'la-text-cell',
    imports: [CommonModule, MatCheckboxModule, GetPipe, FlowPipe],
    template: '<span [class]="props.classNames">{{ (entity | get : props.path) | flow : props.parsers || defaultParser }}</span>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCellComponent extends DynamicTableColumnTemplate<TextProps> {
  defaultParser = identity;
}
